var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutgoing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 30 30",
    height: 17,
    viewBox: "0 0 30 30",
    width: 17,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m29.7 16.097c-.024-.057-.058-.113-.085-.167l-4.829-9.222c-.433-.928-2.716-2.077-2.966-.519.052 1.077 1.242.463 1.656 1.25l4.274 8.169h-9.182c-.429.019-.745.412-.748.828.009 1.557-1.245 2.828-2.803 2.837-1.557.009-2.828-1.245-2.837-2.803.051-.452-.284-.871-.749-.867h-9.18l4.255-8.133c.408-.829 1.616-.192 1.674-1.281-.257-1.576-2.559-.384-2.98.553 0 0-4.816 9.195-4.816 9.195-.077.129-.121.272-.134.42v8.933c.003 1.871 1.519 3.387 3.39 3.389h22.72c1.871-.002 3.388-1.519 3.39-3.39v-8.933c0-.089-.017-.177-.05-.259zm-1.45 9.192c-.001 1.043-.847 1.889-1.89 1.89h-22.72c-1.043-.001-1.889-.847-1.89-1.89v-8.17h8.982c.806 4.817 7.733 4.807 8.535 0h8.983z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.8 5.626 2.45-1.988v9.335c0 .414.336.75.75.75s.75-.336.75-.75v-9.335l2.45 1.988c.761.613 1.704-.543.944-1.165 0 0-3.673-2.979-3.672-2.979-.281-.213-.663-.214-.944 0l-3.674 2.979c-.757.62.18 1.781.946 1.165z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutgoing);
export default __webpack_public_path__ + "static/media/outgoing.d62d4d9c6070d4ba14505e9f7ed28980.svg";
export { ForwardRef as ReactComponent };